<template>
  <b-container>
    <b-row>
      <b-col cols="10"> </b-col>
      <b-col cols="2" class="spinner_col" v-if="$store.state.module.live_en_cours && $store.state.fin_selected_course === 'NON'">
        <SpinnerLive></SpinnerLive>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="12" class="content_container">
        <transition name="fade">
          <Favoris></Favoris>
        </transition>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Favoris from "../components/Live_tab/Favoris.vue";
import SpinnerLive from "@/components/Live_tab/SpinnerLive.vue";

export default {
  components: {
    Favoris,
    SpinnerLive,
  },
  data() {
    return {};
  },
};
</script>

<style lang="sass">
</style>